export const REQUEST_BOX_STATS = 'REQUEST_BOX_STATS';
export const RESTART_BOX_PLAYER = 'RESTART_BOX_PLAYER';
export const RESET_ACTIVE_BOX_STATS = 'RESET_ACTIVE_BOX_STATS';
export const UPDATE_ACTIVE_BOX_STATS = 'UPDATE_ACTIVE_BOX_STATS';
export const SET_BOX_IS_LOADING = 'SET_BOX_IS_LOADING';
